export default "__VITE_ASSET__d64b293b__"